module.exports = __webpack_public_path__ + "img/barcelona.bf4116ca.jpg";